var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrequentlyAskedQuestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11377_7691)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 1.49861C10.4997 1.07051 9.56662 0.996718 8.71645 1.29055L3.10828 2.83592C2.22315 3.02026 1.45096 3.56396 0.966156 4.34614C0.549868 5.169 0.478106 6.12857 0.765433 7.00904L2.26813 12.7764C2.44737 13.6867 2.97606 14.4808 3.73664 14.9793C4.53679 15.4074 5.46987 15.4812 6.32604 15.1857L11.9342 13.6404C12.8133 13.4577 13.5915 12.9123 14.0763 12.1301C14.4866 11.3089 14.5644 10.3477 14.2771 9.46725L12.7744 3.69989C12.5891 2.79129 12.0604 1.99718 11.2998 1.49861Z",
    fill: "#3A7BFF"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.0999756,
    y: -0.599609,
    width: 21.5275,
    height: 21.9116
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_11377_7691_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11377_7691)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4747 4.37344C15.7517 3.69247 14.7923 3.34504 13.8193 3.40758H7.5084C6.52866 3.34504 5.56919 3.69247 4.84621 4.37344C4.18404 5.11694 3.8462 6.10365 3.90701 7.1112V13.6012C3.8462 14.6088 4.18404 15.5955 4.84621 16.339C5.56919 17.0199 6.52866 17.3674 7.5084 17.3048H13.8193C14.7923 17.3674 15.7585 17.0199 16.4815 16.339C17.1369 15.5955 17.4815 14.6088 17.4207 13.6012V7.1112C17.4747 6.10365 17.1369 5.11694 16.4747 4.37344Z",
    fill: "#32C9FD",
    fillOpacity: 0.85
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -7.80273,
    y: -8.73975,
    width: 37.6335,
    height: 37.8345
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_2_11377_7691_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 15,
    d: "M14.5217 9.03623L9.97432 13.7265C9.73783 13.9628 9.42702 14.0948 9.10269 14.0948H7.51484C7.427 14.0948 7.34592 14.0601 7.2851 13.9975C7.22429 13.935 7.19727 13.8516 7.19727 13.7613L7.23781 12.1145C7.24456 11.7879 7.37294 11.4821 7.59592 11.2528L10.8189 7.93835C10.873 7.88276 10.9676 7.88276 11.0216 7.93835L12.15 9.09182C12.2243 9.16825 12.3325 9.21689 12.4473 9.21689C12.6973 9.21689 12.8933 9.00843 12.8933 8.75828C12.8933 8.63321 12.846 8.52203 12.7716 8.43865C12.7514 8.41085 11.677 7.31297 11.677 7.31297C11.6095 7.24348 11.6095 7.12536 11.677 7.05587L12.1297 6.58336C12.5487 6.15255 13.2244 6.15255 13.6433 6.58336L14.5217 7.48669C14.9338 7.91055 14.9338 8.60541 14.5217 9.03623Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11377_7691",
    x: -0.0999756,
    y: -0.599609,
    width: 21.5275,
    height: 21.9116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11377_7691"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_11377_7691_clip_path",
    transform: "translate(0.0999756 0.599609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4747 4.37344C15.7517 3.69247 14.7923 3.34504 13.8193 3.40758H7.5084C6.52866 3.34504 5.56919 3.69247 4.84621 4.37344C4.18404 5.11694 3.8462 6.10365 3.90701 7.1112V13.6012C3.8462 14.6088 4.18404 15.5955 4.84621 16.339C5.56919 17.0199 6.52866 17.3674 7.5084 17.3048H13.8193C14.7923 17.3674 15.7585 17.0199 16.4815 16.339C17.1369 15.5955 17.4815 14.6088 17.4207 13.6012V7.1112C17.4747 6.10365 17.1369 5.11694 16.4747 4.37344Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_11377_7691_clip_path",
    transform: "translate(7.80273 8.73975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5217 9.03623L9.97432 13.7265C9.73783 13.9628 9.42702 14.0948 9.10269 14.0948H7.51484C7.427 14.0948 7.34592 14.0601 7.2851 13.9975C7.22429 13.935 7.19727 13.8516 7.19727 13.7613L7.23781 12.1145C7.24456 11.7879 7.37294 11.4821 7.59592 11.2528L10.8189 7.93835C10.873 7.88276 10.9676 7.88276 11.0216 7.93835L12.15 9.09182C12.2243 9.16825 12.3325 9.21689 12.4473 9.21689C12.6973 9.21689 12.8933 9.00843 12.8933 8.75828C12.8933 8.63321 12.846 8.52203 12.7716 8.43865C12.7514 8.41085 11.677 7.31297 11.677 7.31297C11.6095 7.24348 11.6095 7.12536 11.677 7.05587L12.1297 6.58336C12.5487 6.15255 13.2244 6.15255 13.6433 6.58336L14.5217 7.48669C14.9338 7.91055 14.9338 8.60541 14.5217 9.03623Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11377_7691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequentlyAskedQuestions);
export default __webpack_public_path__ + "static/media/frequentlyAskedQuestions.ca141491b0350568ddaa1019ccb78212.svg";
export { ForwardRef as ReactComponent };